<template>

    <div class="af3-floor-plan-card">
      
      <!-- Floor Plan Image Section -->
      <div class="af3-floor-plan-card-image" v-if="floor_plan.image"> 


        <!-- <img :src="floor_plan.image.url" :alt="floor_plan.image.alt" /> -->

        <floorPlanGalleryComponent v-if="options.floor_plans_loop_show_gallery" :floorplan_gallery="floor_plan.floorplan_gallery" :options="options" />
        <img v-else :src="floor_plan.image.url" :alt="floor_plan.image.alt" />

        <!-- Special Text Overlay -->
        <div class="af3-floor-plan-card-special-text" v-if="floor_plan.current_special_text">
          {{ floor_plan.current_special_text }}
        </div>
       
      </div>
      
      <!-- Floor Plan Details Section -->
      <div class="af3-floor-plan-card-metadata">
        <!-- Title and Basic Info -->
        <div class="af3-floor-plan-card-metadata-title">
          <h6 v-html="floor_plan.title"></h6>
          
          <!-- Unit Details -->
          <div class="af3-floor-plan-card-metadata-details">
            <span>{{ bedrooms_string(floor_plan.bedrooms) }}</span> | 
            <span>{{ floor_plan.bathrooms }} {{options.floor_plans_loop_bathrooms_label}}</span> | 
            <span>{{ floor_plan.size_max }} {{options.floor_plans_loop_square_feet_label}}</span>
          </div>

          <!-- Availability Status -->
          <div class="af3-floor-plan-card-metadata-availability" 
               v-if="floor_plan.is_sold_out && options.floor_plans_loop_show_sold_out_flag">
            <span>{{ options.floor_plans_loop_sold_out_label }}</span>
          </div>
        </div>  

        <!-- Price Display -->
         <div class="af3-floor-plan-card-metadata-price-container">
            <div class="af3-floor-plan-card-metadata-price">
              <p>{{ selected_lease_term ? 'Rent' : 'Starting at' }}</p>
              <span v-dollar-format="displayPrice"></span>
            </div>
            <div class="af3-floor-plan-card-metadata-cta-buttons">


              

              <div class="af3-floor-plan-card-metadata-cta-button-details-container">
                <template v-if="floor_plan.virtual_tour_url">
                  <button type="button" 
                          @click.stop.prevent="openVrTourModal" 
                          class="af3-floor-plan-card-metadata-cta-button-details" 
                          aria-label="View Virtual Tour">
                    <span>{{ options.floor_plans_loop_virtual_tour_button_label }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25.667" height="27.5" viewBox="0 0 25.667 27.5"><g transform="translate(-0.45 0.182)"><path d="M4.917,1.833a.918.918,0,0,1,.917.917v.917a.918.918,0,0,1-.917.917.917.917,0,1,0,0,1.833,2.753,2.753,0,0,0,2.75-2.75V2.75A2.753,2.753,0,0,0,4.917,0a.917.917,0,1,0,0,1.833" transform="translate(0.117 -0.182)"/><path d="M20.917,1.833a.918.918,0,0,1,.917.917v.917a.918.918,0,0,1-.917.917.917.917,0,0,0,0,1.833,2.753,2.753,0,0,0,2.75-2.75V2.75A2.753,2.753,0,0,0,20.917,0a.917.917,0,0,0,0,1.833" transform="translate(-1.217 -0.182)"/><path d="M9.917,3.833h8.25a.917.917,0,1,0,0-1.833H9.917a.917.917,0,1,0,0,1.833" transform="translate(-0.3 -0.349)"/><path d="M24.749,2h-.917a.917.917,0,1,0,0,1.833V7.5h-22V3.833H2.75A.917.917,0,0,0,2.75,2H.917A.917.917,0,0,0,0,2.917V24a.917.917,0,0,0,.917.917H11a.917.917,0,0,0,0-1.833H1.833V9.333h22v4.583a.917.917,0,1,0,1.833,0v-11A.917.917,0,0,0,24.749,2" transform="translate(0.45 -0.349)"/><path d="M25.916,21.5a.917.917,0,0,0-.917.917,4.583,4.583,0,1,1-4.583-4.583.917.917,0,0,0,0-1.833,6.416,6.416,0,1,0,6.416,6.416.917.917,0,0,0-.917-.917" transform="translate(-0.717 -1.516)"/><path d="M19.565,21.018a.919.919,0,1,0-1.3,1.3l1.835,1.83a.916.916,0,0,0,1.3,0l4.583-4.583a.919.919,0,1,0-1.3-1.3L20.75,22.2Z" transform="translate(-1.051 -1.682)"/></g></svg>
                  </button>
                </template>

              </div>


              <div class="af3-floor-plan-card-metadata-cta-button-details-container" v-if="options.floor_plans_loop_link_floorplans">
                <a :href="floor_plan.link_floorplan" class="af3-floor-plan-card-metadata-cta-button-details">
                  <span>{{options.floor_plans_loop_view_details_button_label}}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="23.274" height="20.617" viewBox="0 0 23.274 20.617"><g transform="translate(0 -0.002)"><path d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,1,1,13.675.293L22.985,9.6l.022.024h0a1,1,0,0,1,.267.68h0a1,1,0,0,1-.265.675h0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293"/></g></svg>
                </a>
              </div>


            </div>
        </div>
      </div>

      <!-- Call-to-Action Buttons -->
      <div class="af3-floor-plan-card-cta-buttons">
        <!-- Apply Button -->
        <a v-if="floor_plan.availability_url" 
           :href="floor_plan.availability_url" 
           target="_blank">
          {{ options.floor_plans_loop_apply_button_label }}
        </a>

        <!-- Tour Button - Custom Link -->
        <template v-if="options.floor_plans_loop_custom_tour_link">
          <a :href="options.floor_plans_loop_custom_tour_link"
             :target="options.floor_plans_loop_custom_tour_link !== '#tour-popup' ? '_blank' : undefined">
            {{ options.floor_plans_loop_schedule_tour_button_label }}
          </a>
        </template>
        
        <!-- Tour Button - Popup -->
        <template v-else>
          <a v-if="options.tour_popup_enabled" 
             href="#tour-popup" 
             x-data="" 
             x-on:click.prevent="$store.tourPopup.toggle()">
            {{ options.floor_plans_loop_schedule_tour_button_label }}
          </a>
        </template>
      </div>

   
     

    </div>

    <!-- Virtual Tour Modal -->
    <Teleport to="body">
      <div v-if="showVrTourModal" class="af3-vr-tour-modal-overlay" @click="closeVrTourModal">
        <div class="af3-vr-tour-modal-content" @click.stop>
          <button class="af3-vr-tour-modal-close" @click="closeVrTourModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <iframe 
            v-if="floor_plan.virtual_tour_url" 
            :src="floor_plan.virtual_tour_url" 
            class="af3-vr-tour-modal-iframe"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Teleport>


  


</template>
  
<script>

import { defineComponent, computed, onMounted, watch, toRaw, ref, Teleport } from 'vue';
import floorPlanGalleryComponent from './FloorPlanGalleryComponent.vue';

export default defineComponent({
    name: 'FloorPlanCardComponent',
    
    components: { floorPlanGalleryComponent, Teleport },
   
    props: {
      floor_plan: {
        type: Object,
        required: true
      },
      options: {
        type: Object,
        required: true
      },
      selected_lease_term: {
        type: String,
        required: false,
        default: ''
      },
      resources_url: {
        type: String,
        required: true
      }
    },

    setup(props) {
      // Virtual Tour Modal State
      const showVrTourModal = ref(false);
      
      const openVrTourModal = () => {
        showVrTourModal.value = true;
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
      };
      
      const closeVrTourModal = () => {
        showVrTourModal.value = false;
        // Restore body scroll when modal is closed
        document.body.style.overflow = '';
      };
      
      // Calculate the selected lease option based on the selected_lease_term
      const selectedLeaseOption = computed(() => {
        if (!props.selected_lease_term || !props.floor_plan.lease_options || !props.floor_plan.lease_options.length) {
          return null;
        }
        
        return props.floor_plan.lease_options.find(option => 
          option.composite_key === props.selected_lease_term
        );
      });
      
      // Compute the price to display based on selected lease term
      const displayPrice = computed(() => {
        // Check if we have a valid selected lease term that's not empty
        if (props.selected_lease_term && props.selected_lease_term.trim() !== '') {
          console.log('Using selected lease term:', props.selected_lease_term);
          
          // Find the matching lease option
          if (selectedLeaseOption.value) {
            // Convert the rent string to a number
            const rentValue = selectedLeaseOption.value.rent;
            if (rentValue) {
              // Remove commas and other non-numeric characters (except decimal point)
              const cleanedRent = rentValue.replace(/,/g, '');
              // Parse the rent value as a float
              const parsedRent = parseFloat(cleanedRent);
              console.log('Parsed rent:', parsedRent, 'from:', rentValue, 'cleaned:', cleanedRent);
              if (!isNaN(parsedRent)) {
                return parsedRent;
              }
            }
          }
        } else {
          console.log('No selected lease term, using default price');
        }
        
        // Fall back to default price_min if no lease term is selected or if "Any" is selected
        return props.floor_plan.price_min;
      });
      
      // For debugging and tracking changes
      watch(() => props.selected_lease_term, 
        (newValue, oldValue) => {
          console.log(`[WATCH] selected_lease_term changed from "${oldValue}" to "${newValue}"`);
          if (newValue) {
            const option = props.floor_plan.lease_options.find(opt => opt.composite_key === newValue);
            console.log('[WATCH] Matching lease option:', option);
            if (option) {
              console.log('[WATCH] Rent value type:', typeof option.rent, 'Value:', option.rent);
            }
          }
      }, { immediate: true });
      
      const bedrooms_string = (bedrooms) => {
        if (bedrooms == 0) {
          return 'Studio';
        } else {
          return bedrooms + ' ' + props.options.floor_plans_loop_bedrooms_label;
        }
      }

      const formatAvailableDate = (dateString) => {
        if (!dateString) return '';
        
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
          });
        } catch (e) {
          console.error('Error formatting date:', e);
          return dateString;
        }
      }

      return {
        bedrooms_string,
        formatAvailableDate,
        selectedLeaseOption,
        displayPrice,
        showVrTourModal,
        openVrTourModal,
        closeVrTourModal
      };
    }
});
</script>